module.exports = __webpack_public_path__ + "static/img/interest01.7bb3df1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/interests_images/interest01.png
// module id = SkEe
// module chunks = 0